import z from 'zod';
import { Grade, Subject, SubjectLabel, UserGroup, XeroDepartment } from './enums';
import { CountrySchema, ProfileIconSchema } from './schemas';

export const StaffUserGroups = [
  UserGroup.Teachers,
  UserGroup.Admins,
  UserGroup.Managers,
  UserGroup.Owners,
];

export const DEFAULT_PROFILE_ICON: z.infer<typeof ProfileIconSchema> = {
  color: '#0c374d',
};

export const DEFAULT_COUNTRY: z.infer<typeof CountrySchema> = 'Australia';

export const SUBJECTS = [
  {
    key: Subject.Chemistry,
    value: Subject.Chemistry,
    label: SubjectLabel.Chemistry,
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Chemistry,
    },
  },
  {
    key: Subject.Physics,
    value: Subject.Physics,
    label: SubjectLabel.Physics,
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Physics,
    },
  },
  {
    key: Subject.MathsExt1,
    value: Subject.MathsExt1,
    label: SubjectLabel.MathsExt1,
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Mathematics,
    },
  },
  {
    key: Subject.MathsExt2,
    value: Subject.MathsExt2,
    label: SubjectLabel.MathsExt2,
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Mathematics,
    },
  },
];

export const GRADES = [
  {
    key: Grade.HSC,
    value: Grade.HSC,
    label: 'HSC',
  },
  {
    key: Grade.Prelim,
    value: Grade.Prelim,
    label: 'Prelim',
  },
];
